import { Filter, SearchInput } from "react-admin";
import { StateInput, useFieldLabel } from "ra-friendsofbabba";
import {
  TechnicalReportGroupInput,
  UniversityDepartmentInput,
  UniversityInput,
} from "../component/input";

import React from "react";

const ResourceStateInput = ({ resource, customResource, ...props }) => {
  const fieldLabel = useFieldLabel({ resource });
  return (
    <StateInput
      {...props}
      resource={customResource}
      label={fieldLabel(props.source)}
      fullWidth
    />
  );
};
const Filters = (props) => {
  return (
    <Filter {...props}>
      <SearchInput source="q" alwaysOn fullWidth />
      <UniversityInput source="university_id" alwaysOn fullWidth />
      <UniversityDepartmentInput
        source="university_department_id"
        filterValues={props.filterValues}
        fullWidth
      />
      <ResourceStateInput
        customResource="technical-reports"
        source="state"
        fullWidth
      />
      <ResourceStateInput
        customResource="technical-report-evals"
        source="tre_state"
        fullWidth
      />
      <TechnicalReportGroupInput source="technical_report_group_id" />
    </Filter>
  );
};
export default Filters;
